import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import AnswerDisplay from "components/questions/modify/AnswerDisplay";
import AnswerEdit from "components/questions/modify/AnswerEdit";

class AnswerList extends Component {
  onDragEnd(result) {
    const { source, destination } = result;

    if (!destination) {
      return;
    }

    let new_answers = [].concat(this.props.answers);

    const [item_to_move] = new_answers.splice(source.index, 1);
    new_answers.splice(destination.index, 0, item_to_move);

    this.props.changeAnswerOrder(new_answers);
  }

  render() {
    const $answerList = this.props.answers.map((answer, index) => {
      if (answer && !answer.is_deleted) {
        return this.props.editAnswerObject === answer ? (
          <AnswerEdit
            index={index}
            editAnswerText={this.props.editAnswerText}
            editAnswer={this.props.editAnswer}
            deleteAnswer={this.props.deleteAnswer}
            handleChange={this.props.handleChange}
            cancelAnswerEdit={this.props.cancelAnswerEdit}
            confirmAnswerEdit={this.props.confirmAnswerEdit}
          />
        ) : (
          <Draggable draggableId={index} index={index} key={index}>
            {provided => (
              <div ref={provided.innerRef} {...provided.draggableProps}>
                <AnswerDisplay
                  dragHandle={provided}
                  index={answer.id}
                  answer={answer}
                  editAnswer={this.props.editAnswer}
                  deleteAnswer={this.props.deleteAnswer}
                />
              </div>
            )}
          </Draggable>
        );
      }
    });

    return (
      <DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
        <Droppable droppableId="droppable">
          {provided => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {" "}
              <ul id="answersList">{$answerList}</ul>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

export default AnswerList;



// WEBPACK FOOTER //
// ./src/components/questions/modify/AnswerList.js